module.exports = {
	"config": {
		"siteTitle": "Gatsby Starter Site",
		"linkPrefix": "/gatsby-starter-default"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"path": "_template.jsx",
				"isAbsolute": false,
				"absolute": "/opt/build/repo/_template.jsx",
				"root": "",
				"dirname": "",
				"basename": "_template.jsx",
				"extname": ".jsx",
				"name": "_template",
				"ext": "jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"path": "404.md",
				"isAbsolute": false,
				"absolute": "/opt/build/repo/404.md",
				"root": "",
				"dirname": "",
				"basename": "404.md",
				"extname": ".md",
				"name": "404",
				"ext": "md"
			},
			"requirePath": "404.md",
			"path": "/404/",
			"data": {}
		},
		{
			"file": {
				"path": "components/Container.js",
				"isAbsolute": false,
				"absolute": "/opt/build/repo/components/Container.js",
				"root": "",
				"dirname": "components",
				"basename": "Container.js",
				"extname": ".js",
				"name": "Container",
				"ext": "js"
			},
			"requirePath": "components/Container.js",
			"path": "/components/Container/",
			"data": {}
		},
		{
			"file": {
				"path": "components/Form.js",
				"isAbsolute": false,
				"absolute": "/opt/build/repo/components/Form.js",
				"root": "",
				"dirname": "components",
				"basename": "Form.js",
				"extname": ".js",
				"name": "Form",
				"ext": "js"
			},
			"requirePath": "components/Form.js",
			"path": "/components/Form/",
			"data": {}
		},
		{
			"file": {
				"path": "components/Header.js",
				"isAbsolute": false,
				"absolute": "/opt/build/repo/components/Header.js",
				"root": "",
				"dirname": "components",
				"basename": "Header.js",
				"extname": ".js",
				"name": "Header",
				"ext": "js"
			},
			"requirePath": "components/Header.js",
			"path": "/components/Header/",
			"data": {}
		},
		{
			"file": {
				"path": "index.js",
				"isAbsolute": false,
				"absolute": "/opt/build/repo/index.js",
				"root": "",
				"dirname": "",
				"basename": "index.js",
				"extname": ".js",
				"name": "index",
				"ext": "js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"path": "thanks.js",
				"isAbsolute": false,
				"absolute": "/opt/build/repo/thanks.js",
				"root": "",
				"dirname": "",
				"basename": "thanks.js",
				"extname": ".js",
				"name": "thanks",
				"ext": "js"
			},
			"requirePath": "thanks.js",
			"path": "/thanks/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 405
// module chunks = 0